/**
 * @generated SignedSource<<df2b366d7873045c53a0e34eb02e8c86>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CalcSourceEnum = "BANK" | "DERIVED" | "STRIPE" | "%future added value";
export type CalcUnitEnum = "CENTS" | "COUNT" | "POINTS" | "RATIO" | "%future added value";
export type CohortDimensionEnum = "COHORT" | "COUNTRY" | "PLAN_TIER" | "SEAT_BAND" | "TENURE" | "%future added value";
export type MetricExplanationEnum = "ANNUAL_ARR" | "ANNUAL_EBITDA" | "ANNUAL_REVENUE_GROWTH" | "ARPU" | "ARR" | "CAC" | "EBITDA" | "GROSS_MARGIN" | "GRR" | "LOGO_RETENTION" | "LTV" | "NET_CASH" | "NRR" | "PROFIT_MARGIN" | "REVENUE_GROWTH" | "RULE_OF_40" | "TTM_REVENUE" | "%future added value";
export type explainPanel_Query$variables = {
  dimension?: CohortDimensionEnum | null | undefined;
  metric: MetricExplanationEnum;
  month?: string | null | undefined;
  value?: string | null | undefined;
};
export type explainPanel_Query$data = {
  readonly metricExplanation: {
    readonly children: ReadonlyArray<{
      readonly children: ReadonlyArray<{
        readonly drill: {
          readonly categoryId: string | null | undefined;
          readonly classification: string | null | undefined;
          readonly excludeDistributions: boolean | null | undefined;
          readonly flow: string | null | undefined;
          readonly from: string | null | undefined;
          readonly pnlLine: string | null | undefined;
          readonly to: string | null | undefined;
        } | null | undefined;
        readonly formula: string | null | undefined;
        readonly key: string;
        readonly label: string;
        readonly note: string | null | undefined;
        readonly source: CalcSourceEnum;
        readonly unit: CalcUnitEnum;
        readonly value: number | null | undefined;
      }>;
      readonly drill: {
        readonly categoryId: string | null | undefined;
        readonly classification: string | null | undefined;
        readonly excludeDistributions: boolean | null | undefined;
        readonly flow: string | null | undefined;
        readonly from: string | null | undefined;
        readonly pnlLine: string | null | undefined;
        readonly to: string | null | undefined;
      } | null | undefined;
      readonly formula: string | null | undefined;
      readonly key: string;
      readonly label: string;
      readonly note: string | null | undefined;
      readonly source: CalcSourceEnum;
      readonly unit: CalcUnitEnum;
      readonly value: number | null | undefined;
    }>;
    readonly drill: {
      readonly categoryId: string | null | undefined;
      readonly classification: string | null | undefined;
      readonly excludeDistributions: boolean | null | undefined;
      readonly flow: string | null | undefined;
      readonly from: string | null | undefined;
      readonly pnlLine: string | null | undefined;
      readonly to: string | null | undefined;
    } | null | undefined;
    readonly formula: string | null | undefined;
    readonly key: string;
    readonly label: string;
    readonly note: string | null | undefined;
    readonly source: CalcSourceEnum;
    readonly unit: CalcUnitEnum;
    readonly value: number | null | undefined;
  };
};
export type explainPanel_Query = {
  response: explainPanel_Query$data;
  variables: explainPanel_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "dimension"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "metric"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "month"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "value"
},
v4 = [
  {
    "kind": "Variable",
    "name": "dimension",
    "variableName": "dimension"
  },
  {
    "kind": "Variable",
    "name": "metric",
    "variableName": "metric"
  },
  {
    "kind": "Variable",
    "name": "month",
    "variableName": "month"
  },
  {
    "kind": "Variable",
    "name": "value",
    "variableName": "value"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "key",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "formula",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "unit",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "source",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "note",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pnlLine",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "flow",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "excludeDistributions",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "classification",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "categoryId",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "from",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "to",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "concreteType": "CalcDrill",
  "kind": "LinkedField",
  "name": "drill",
  "plural": false,
  "selections": [
    (v12/*: any*/),
    (v13/*: any*/),
    (v14/*: any*/),
    (v15/*: any*/),
    (v16/*: any*/),
    (v17/*: any*/),
    (v18/*: any*/)
  ],
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "concreteType": "CalcDrill",
  "kind": "LinkedField",
  "name": "drill",
  "plural": false,
  "selections": [
    (v12/*: any*/),
    (v13/*: any*/),
    (v14/*: any*/),
    (v15/*: any*/),
    (v16/*: any*/),
    (v17/*: any*/),
    (v18/*: any*/),
    (v20/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "explainPanel_Query",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "CalcNode",
        "kind": "LinkedField",
        "name": "metricExplanation",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          (v19/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "CalcNode",
            "kind": "LinkedField",
            "name": "children",
            "plural": true,
            "selections": [
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v19/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "CalcNode",
                "kind": "LinkedField",
                "name": "children",
                "plural": true,
                "selections": [
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v19/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "explainPanel_Query",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "CalcNode",
        "kind": "LinkedField",
        "name": "metricExplanation",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          (v21/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "CalcNode",
            "kind": "LinkedField",
            "name": "children",
            "plural": true,
            "selections": [
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v21/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "CalcNode",
                "kind": "LinkedField",
                "name": "children",
                "plural": true,
                "selections": [
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v21/*: any*/),
                  (v20/*: any*/)
                ],
                "storageKey": null
              },
              (v20/*: any*/)
            ],
            "storageKey": null
          },
          (v20/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "7b716f444fe4bd6b8480f77d43eb006e",
    "id": null,
    "metadata": {},
    "name": "explainPanel_Query",
    "operationKind": "query",
    "text": "query explainPanel_Query(\n  $metric: MetricExplanationEnum!\n  $month: String\n  $dimension: CohortDimensionEnum\n  $value: String\n) {\n  metricExplanation(metric: $metric, month: $month, dimension: $dimension, value: $value) {\n    key\n    label\n    formula\n    value\n    unit\n    source\n    note\n    drill {\n      pnlLine\n      flow\n      excludeDistributions\n      classification\n      categoryId\n      from\n      to\n      id\n    }\n    children {\n      key\n      label\n      formula\n      value\n      unit\n      source\n      note\n      drill {\n        pnlLine\n        flow\n        excludeDistributions\n        classification\n        categoryId\n        from\n        to\n        id\n      }\n      children {\n        key\n        label\n        formula\n        value\n        unit\n        source\n        note\n        drill {\n          pnlLine\n          flow\n          excludeDistributions\n          classification\n          categoryId\n          from\n          to\n          id\n        }\n        id\n      }\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "91388baef64acd3c22729bb4c923ec1e";

export default node;
